interface NguTrackingConfig {
  metaPixelId: string | null;
  gaMeasurementId: string | null;
  googleAdsConversionId: string | null;
}

let cached: NguTrackingConfig | null = null;
let fetching: Promise<NguTrackingConfig> | null = null;

/**
 * Returns the already-fetched tracking config synchronously, or null if not
 * yet loaded. Use this in synchronous click handlers where an await is not
 * possible; the cache is warm after the first getNguTrackingConfig() call.
 */
export function getCachedNguTrackingConfig(): NguTrackingConfig | null {
  return cached;
}

export async function getNguTrackingConfig(): Promise<NguTrackingConfig> {
  if (cached) return cached;
  if (!fetching) {
    fetching = fetch("/api/netglowup/tracking-config")
      .then(r => r.ok ? r.json() : { metaPixelId: null, gaMeasurementId: null, googleAdsConversionId: null })
      .then((cfg: NguTrackingConfig) => {
        cached = cfg;
        return cfg;
      })
      .catch(() => {
        const fallback: NguTrackingConfig = { metaPixelId: null, gaMeasurementId: null, googleAdsConversionId: null };
        return fallback;
      });
  }
  return fetching;
}
